module.exports = __webpack_public_path__ + "img/client_Logo.35b98c49.png";